import { atom } from 'recoil'
import { IProjectType } from '../../projectTypes.types'

interface IProjectTypesTableAtom {
  items: IProjectType[]
}

const projectTypesTableAtom = atom<IProjectTypesTableAtom>({
  key: 'tables/admin/project-types',
  default: { items: [] },
})
export default projectTypesTableAtom
